import { SxProps } from '@mui/material';
export const shortDescriptionSX: SxProps = {
	paddingTop: '10px',
	display: '-webkit-box',
	WebkitBoxOrient: 'vertical',
	WebkitLineClamp: 4,
	overflow: 'hidden',
	maxHeight: '91px',
	mt: '15px',
};
